import React, { useState, useEffect, useRef } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Messages } from 'primereact/messages';
import { APPROVECPPREQUEST_URL, CPPCODELIST, CPPREQUESTLIST_URL, APPROVEPROGRAMPROJECTREQUEST_URL, PROGRAMPROJECTREQUESTLIST_URL } from "../../constants";
import axios from "../../datasource/axios";
import { hideLoader, showLoader } from "../../datasource/msal";
import './CppoActionDialog.css';
import { Toast } from 'primereact/toast';
import Spinner from "../../components/shared/spinner.jsx";

export default function CPPActionModal(props: any) {
  const toast = useRef<any>(null);
  function HideDialog() {
    props.CPPActions(false);
    setVisible(false);
    setShowReasonInput(false);
    setShowConfirmation(false);
    setActionReason('');
    setCurrentAction('');
  }

  function navigateHome() {
    HideDialog();
    fetchDashboard();
  }

  const [visible, setVisible] = useState(false);
  const [actionMessage, setActionMessage] = useState('');
  const [processingMessage, setProcessingMessage] = useState('');
  const [finalActionText, setFinalActionText] = useState('');
  const [currentAction, setCurrentAction] = useState('');
  const [showReasonInput, setShowReasonInput] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showProcessing, setShowProcessing] = useState(false);
  const [actionReason, setActionReason] = useState('');
  const [rowId, setRowId] = useState(0);
  const [showdivLoader, setdivShowLoader] = useState(false);

  useEffect(() => {
    let actionType = props.mode.toLowerCase();
    setVisible(props.visible);
    setRowId(props.rowId);
    if (visible && !currentAction) {
      setShowConfirmation(true);
    } else {
      setShowConfirmation(false);
    }
    setActionMessage("Are you sure you want to " + actionType + " this request?");
    if (actionType === 'approve') {
      setFinalActionText("Approve Request");
    } else {
      setFinalActionText("Reject Request");
    }
  })


  const handleChange = (event: any) => {
    setActionReason(event.target.value);
    var element = document.getElementById("iLabel");
    element?.classList.remove("action-label-red");
    element?.classList.add("action-label");
  };

  const nextStep = (action: string) => {

    if (action === 'proceed') {
      setShowConfirmation(false);
      setShowReasonInput(true);
      setCurrentAction('proceed');
    } else {
      setCurrentAction('');
      HideDialog();
    }
  }

  const approveCppRequestListByRequestId = async (action?: string, comment?: string) => {

    showLoader();
    setdivShowLoader(true);

    let BASE_URL = process.env.REACT_APP_API_URI;
    let url = BASE_URL + APPROVECPPREQUEST_URL + "/" + rowId + "/" + action + "/" + comment;

    let successMsg = "";
    let errorMsg = "";

    if (action === "approve") {
      successMsg = props.type === 1 ? "CPP Request" : "Program/Project Request" + " has been approved";
      errorMsg = "Unable to approve " + (props.type === 1 ? "CPP Request" : "Program/Project Request");
      setProcessingMessage("Approving request, please wait...");
    } else {
      successMsg = props.type === 1 ? "CPP Request" : "Program/Project Request" + " has been rejected";
      errorMsg = "Unable to reject " + (props.type === 1 ? "CPP Request" : "Program/Project Request");
      setProcessingMessage("Rejecting request, please wait...");
    }

    setShowReasonInput(false);
    setShowProcessing(true);

    const res: any = await new Promise((resolve, reject) => {
      try {
        showLoader();
        axios.postRequest(url)
          .then((res: any) => {
            hideLoader();
            setdivShowLoader(false);
            resolve(res);
          })
          .catch((err: any) => {
            setdivShowLoader(false);
            resolve(err);
          });
      } catch (error) {
        setdivShowLoader(false);
        reject(error);
      }
    });
    if (res.status == "Success") {
      setShowProcessing(false);
      toast.current.show({ severity: 'success', summary: 'Success', detail: successMsg, life: 10000 });
      await sleep(2000);
      navigateHome();
    } else {
      setShowProcessing(false);
      const apiError = res?.response?.data?.error ?? errorMsg;
      toast.current.show({ severity: 'error', summary: 'Error', detail: apiError, life: 10000 });
      await sleep(3000);
      HideDialog();
    }
    setdivShowLoader(false);
  };

  const approveProgramProjectByRequestId = async (action?: string, comment?: string) => {

    showLoader();
    setdivShowLoader(true);

    let BASE_URL = process.env.REACT_APP_API_URI;
    let url = BASE_URL + APPROVEPROGRAMPROJECTREQUEST_URL;

    var data = {
      id: rowId,
      managercomments: comment,
      status: action
    };

    let successMsg = "";
    let errorMsg = "";

    if (action === "approve") {
      successMsg = props.type === 1 ? "CPP Request" : "Program/Project Request" + " has been approved";
      errorMsg = "Unable to approve " + (props.type === 1 ? "CPP Request" : "Program/Project Request");
      setProcessingMessage("Approving request, please wait...");
    } else {
      successMsg = props.type === 1 ? "CPP Request" : "Program/Project Request" + " has been rejected";
      errorMsg = "Unable to reject " + (props.type === 1 ? "CPP Request" : "Program/Project Request");
      setProcessingMessage("Rejecting request, please wait...");
    }

    setShowReasonInput(false);
    setShowProcessing(true);

    const res: any = await new Promise((resolve, reject) => {
      try {
        showLoader();
        axios.postRequest(url, data)
          .then((res: any) => {
            hideLoader();
            setdivShowLoader(false);
            resolve(res);
          })
          .catch((err: any) => {
            setdivShowLoader(false);
            resolve(err);
          });
      } catch (error) {
        setdivShowLoader(false);
        reject(error);
      }
    });
    if (res.status == "Success") {
      setShowProcessing(false);
      toast.current.show({ severity: 'success', summary: 'Success', detail: successMsg, life: 10000 });
      await sleep(2000);
      navigateHome();
    } else {
      setShowProcessing(false);
      toast.current.show({ severity: 'error', summary: 'Error', detail: errorMsg, life: 10000 });
      await sleep(3000);
      HideDialog();
    }
    setdivShowLoader(false);
  };

  const sleep = async (milliseconds: number) => {
    await new Promise(resolve => {
      return setTimeout(resolve, milliseconds)
    });
  };

  const getProgramProjectRequestListByUserid = () => {
    var groups = props?.roles;

    let BASE_URL = process.env.REACT_APP_API_URI;
    let url = BASE_URL + PROGRAMPROJECTREQUESTLIST_URL;

    return new Promise((resolve, reject) => {
      try {
        axios.getRequest(url)
          .then((res: any) => {
            hideLoader();
            resolve(res);
          })
          .catch((err: any) => {
            resolve(err);
          });
      } catch (error: any) {
        reject(error);
      }
    });
  };

  const getCppRequestListByUserid = () => {
    var groups = sessionStorage.getItem("groups");

    let BASE_URL = process.env.REACT_APP_API_URI;
    let url = BASE_URL + CPPREQUESTLIST_URL;

    return new Promise((resolve, reject) => {
      try {
        axios.getRequest(url)
          .then((res: any) => {
            hideLoader();
            resolve(res.data);
          })
          .catch((err: any) => {
            resolve(err);
          });
      } catch (error) {
        reject(error);
      }
    });
  };

  const fetchDashboard = async () => {
    if (props?.type === 1) {
      const response: any = await getCppRequestListByUserid();
      const mappings = response?.responseMappings;
      props.handleCallback(mappings);
    }
    else {
      const response: any = await getProgramProjectRequestListByUserid();
      props.handleCallback(response);
    }
  }

  const completeAction = async () => {

    var msg = 'CPP Request has been ';
    var action;

    if (finalActionText.includes('Approve')) {
      action = "approve";
      msg += "approved";

    } else {
      action = "reject";
      msg += "rejected";
    }

    if (!actionReason) {
      var element = document.getElementById("iLabel");
      element?.classList.remove("action-label");
      element?.classList.add("action-label-red");

    } else {
      if (props?.type === 1) {
        approveCppRequestListByRequestId(action, actionReason);
      }
      else {
        approveProgramProjectByRequestId(action, actionReason);
      }
    }
  }

  return (
    <div>
      <Dialog visible={visible} style={{ width: '800px', height: '380px' }} modal={true} onHide={HideDialog}>
        <Toast ref={toast} />
        {showdivLoader && (
          <div className="divSpinnermodal">
            <Spinner />
          </div>
        )}
        <br /><br />
        <h4 className="actionCentered">{props.mode} {props.type === 1 ? "CPP Request" : "Program/Project Request"}</h4>
        <hr></hr>
        {showProcessing ?
          <div className="actionCentered"> {processingMessage}  </div>
          : null}
        {showConfirmation ?
          <div>
            <div className="actionCentered"> {actionMessage}  </div>
            <br />
            <div className="actionCentered">
              <Button className="proceed" severity={props.mode == 'Approve' ? "success" : "danger"} type="button" label="Yes" onClick={() => nextStep('proceed')} />&nbsp;&nbsp; <Button className='cancel' type="button" label="No" onClick={() => nextStep('cancel')} />
            </div>
          </div>
          : null}

        {showReasonInput ?
          <div className="actionCentered">
            <label id='iLabel' className="action-label" htmlFor='iName'>*Please enter a reason before proceeding</label>
            <InputTextarea onChange={handleChange} rows={5} cols={30} className="action-input" id='iReason' name='iReason' />
            <br />
            <br />
            <Button className="final-action" severity={props.mode == 'Approve' ? "success" : "danger"} type="button" label={finalActionText} onClick={() => completeAction()} />
            &nbsp;&nbsp;
            <Button className="cancel-action" type="button" label="Cancel" onClick={() => HideDialog()} />
          </div>
          : null}
      </Dialog>
    </div>
  )
}